var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-to-top",attrs:{"role":"button"},on:{"click":_vm.scrollToTop}},[_c('img',{attrs:{"src":require("../images/arrow-up.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }